<template>
  <div
    class="filtered-posts-list"
    v-observe-visibility="visibilityChanged"
    :class="['type-' + postType, baseAnimation, { 'has-search': search }]"
  >
    <SearchForm
      @changed="searchChange"
      :placeholder="searchPlaceholder"
      class="animate-delay-02"
      v-if="search"
      v-observe-visibility="visibilityChanged"
      :class="[baseAnimation]"
    />
    <CategoriesFilter
      class="animate-delay-02"
      v-observe-visibility="visibilityChanged"
      :class="[baseAnimation]"
      :key="taxonomy"
      v-if="filters"
      :taxonomy="taxonomy"
      :multiple="filtersMultiple"
      @filters="updateFilters"
    >
      <div v-if="currentPostType === 'events'" class="past-events">
        <button
          class="btn swap-filter"
          :class="{ active: pastEvents }"
          @click="pastEvents = !pastEvents"
        >
          Se tidligere arrangementer
        </button>
      </div>
    </CategoriesFilter>
    <transition-group
      name="company"
      tag="section"
      v-if="elementsToShow && elementsToShow.length"
      class="article-list archive-list padding_large animate-delay-03 filters-resoultats"
    >
      <component
        :is="componentModule"
        v-for="(article, i) in elementsToShow"
        :key="article.id"
        v-if="i < perPage"
        :id="article.id"
      />
    </transition-group>
    <section
      v-else-if="!isPageLoaded"
      v-observe-visibility="visibilityChanged"
      :class="[baseAnimation]"
      class="article-list archive-list padding_large"
    >
      <component :is="componentModule" />
      <component :is="componentModule" />
      <component :is="componentModule" />
      <component :is="componentModule" />
      <component :is="componentModule" />
      <component :is="componentModule" />
    </section>
    <section v-else class="article-list archive-not-found padding_large">
      <ModuleHeading
        >Ingenting funnet, vennligst prøv et annet filter</ModuleHeading
      >
    </section>
    <button
      v-observe-visibility="visibilityChangedLoadMore"
      @click="loadMore"
      v-show="elementsToShow.length > perPage"
      class="btn load-more"
      :class="'load-' + postType"
    >
      <span class="icon" v-html="svgIcons.load"> </span>
      <span class="text">Last inn flere {{ loadMoreText }}</span>
    </button>
  </div>
</template>

<script>
import _debounce from "lodash.debounce";

import SinglePost from "@/components/blocks/SinglePost";
import SingleEvent from "@/components/blocks/SingleEvent";
import SearchBlock from "@/components/blocks/SearchBlock";
import StyledIcon from "@/components/elements/StyledIcon";
import SingleHelp from "@/components/blocks/SingleHelp";
import CategoriesFilter from "@/components/blocks/CategoriesFilter";
import SearchForm from "@/components/blocks/SearchForm";

import { mapGetters } from "vuex";

export default {
  name: "filtered-posts-list",
  props: {
    taxonomy: {
      type: String,
      default: "category"
    },
    searchPage: {
      type: Boolean,
      default: false
    },
    postType: {
      type: String,
      default: "post"
    },
    filtersMultiple: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Boolean,
      default: false
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    search: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeFilters: [],
      perPageBase: 12,
      perPage: 12,
      perLoad: 6,
      searchString: "",
      pastEvents: false
    };
  },
  watch: {
    elementsToShow() {
      //this.nullLoadMore()
    },
    $route: {
      deep: true,
      handler(to) {
        this.searchChange(to.query.search ? to.query.search : "");
      }
    }
  },
  computed: {
    ...mapGetters([
      "getPosts",
      "getEvents",
      "isPageLoaded",
      "getPostsData",
      "currentPostType"
    ]),
    postsToDisplay() {
      let posts = null;
      let type = this.postType.toLowerCase();
      if (type === "posttypes") {
        const postData = this.getPostsData;
        posts = [];
        Object.keys(postData).forEach(function(item) {
          if (item !== "attachment") posts.push(...postData[item]);
        });
      } else {
        if (this.postType !== "events") {
          posts = this.getPosts(null, this.postType);
        } else {
          posts = this.getEvents([], this.pastEvents);
        }
      }
      return posts;
    },
    loadMoreText() {
      let text = "";
      let type = this.postType.toLowerCase();
      switch (type) {
        case "events":
          text = "arrangementer";
          break;
        case "help":
          text = "hjelpesider";
          break;
        case "posttypes":
          text = "";
          break;
        default:
          text = "artikler";
          break;
      }
      return text;
    },
    elementsToShow() {
      const VM = this;
      if (!VM.postsToDisplay) return false;
      let element = VM.postsToDisplay;
      let type = this.postType.toLowerCase();
      let title = "";
      let content = "";
      if (VM.activeFilters.length && VM.filters) {
        if (type !== "posttypes") {
          element = element.filter(it => {
            let canShow = false;
            if (it.acf && it.acf._categories && it.acf._categories.length) {
              it.acf._categories.forEach(taxID => {
                if (VM.activeFilters.indexOf(taxID) !== -1) {
                  canShow = true;
                }
              });
            }
            return canShow;
          });
        } else {
          element = element.filter(it => {
            return VM.activeFilters.indexOf(it.post_type) !== -1;
          });
        }
      }

      if (VM.searchString !== "" && element && element.length > 0) {
        const searchString = VM.searchString.toLowerCase();
        element = element.filter(it => {
          let existItem = false;
          if (it.acf && it.acf.modules) {
            let modules = it.acf.modules;
            modules.forEach(moduleItem => {
              let moduleName = moduleItem.acf_fc_layout;
              switch (moduleName) {
                case "links":
                  if (
                    moduleItem.title.toLowerCase().indexOf(searchString) !== -1
                  )
                    existItem = true;
                  break;
                case "news":
                  break;
                case "gallery":
                  break;
                case "logo_box":
                  content = moduleItem.box[0].content.stripHtml();
                  if (moduleItem.box[1]) {
                    content += moduleItem.box[1].content.stripHtml();
                  }
                  if (content.toLowerCase().indexOf(searchString) !== -1) {
                    existItem = true;
                  }
                  break;
                case "single_event":
                  break;
                case "alert":
                  if (
                    moduleItem.alert_title
                      .toLowerCase()
                      .indexOf(searchString) !== -1
                  )
                    existItem = true;
                  break;
                case "text_block":
                  title = moduleItem.text_header;
                  content = moduleItem.text_columns[0].content.stripHtml();
                  if (moduleItem.text_columns[1]) {
                    content += moduleItem.text_columns[1].content.stripHtml();
                  }
                  if (
                    content.toLowerCase().indexOf(searchString) !== -1 ||
                    title.toLowerCase().indexOf(searchString) !== -1
                  ) {
                    existItem = true;
                  }
                  break;
                case "text_image":
                  content = moduleItem.text_side.content.stripHtml();
                  title = moduleItem.text_side.title;
                  if (
                    content.toLowerCase().indexOf(searchString) !== -1 ||
                    title.toLowerCase().indexOf(searchString) !== -1
                  ) {
                    existItem = true;
                  }
                  break;
              }
            });
          }
          return (
            it.title.rendered.toLowerCase().indexOf(searchString) !== -1 ||
            it.excerpt.rendered.toLowerCase().indexOf(searchString) !== -1 ||
            it.content.rendered.toLowerCase().indexOf(searchString) !== -1 ||
            existItem
          );
        });
      }

      return element;
    },
    componentModule() {
      let component = SinglePost;
      let type = this.postType.toLowerCase();
      switch (type) {
        case "events":
          component = SingleEvent;
          break;
        case "posttypes":
          component = SearchBlock;
          break;
        case "help":
          component = SingleHelp;
          break;
      }
      return component;
    }
  },
  components: {
    CategoriesFilter,
    SearchForm,
    StyledIcon
  },
  methods: {
    searchChange(val) {
      this.searchString = val;
      this.updateRoute();
    },
    updateRoute: _debounce(function() {
      //            this.$router.replace({ query: { ...this.$route.query, search: this.searchString} })
      let query = {};
      if (this.activeFilters) {
        query.kategori = this.activeFilters;
      }
      if (this.searchString) {
        query.search = this.searchString;
      }
      this.$router.push({ query });
    }, 100),
    visibilityChangedLoadMore(isVisivle) {
      if (isVisivle) this.loadMore();
    },
    loadMore() {
      if (this.elementsToShow.length > this.perPage)
        this.perPage += this.perLoad;
    },
    nullLoadMore() {
      this.perPage = this.perPageBase;
    },
    updateFilters(filters) {
      this.activeFilters = filters;
      this.updateRoute();
    }
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";
.company {
  transform-origin: 10% 50%;
  backface-visibility: hidden;
  &-move {
    transition: all 600ms ease-in-out 50ms;
  }
  &-enter-active {
    transition: all 300ms ease-out;
  }

  &-leave-active {
    transition: all 200ms ease-in;
    position: absolute;
    z-index: 0;
  }

  &-enter,
  &-leave-to {
    opacity: 0;
  }
  &-enter {
    transform: scale(0.9);
  }
}
.categoreis-filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .past-events .swap-filter {
    margin-left: 20px;
    background-color: #fff;
    color: $fontColor;
    transition: all 0.15s ease-in-out;
    border: 2px solid $dark;
    &.active {
      background-color: $dark;
      color: #fff;
    }
    &:hover {
      background-color: gray;
      color: #fff;
    }
  }
}

.filtered-posts-list {
  margin-bottom: 20px;
  .article-list {
    margin-left: -12px;
    margin-right: -12px;
    margin-bottom: -25px;
    .block-single-post {
      @include mquery(767px) {
        max-width: 50%;
      }
      @include mquery(460px) {
        max-width: 100%;
      }
    }
  }
  .btn.load-more {
    margin: 0 auto 50px;
    margin-top: 25px;
    display: block;
    background-color: $purple;
    &.load-post {
      background-color: #fff;
      color: $fontColor;
      svg g {
        fill: $fontColor !important;
      }
    }
  }
  .single-event-block {
    width: 50%;
    padding-left: 12px;
    padding-right: 12px;
    margin-bottom: 25px;
    @include mquery(767px) {
      max-width: 100%;
      width: 100%;
    }
  }
}
</style>
